import { Quote } from '@britishcouncil/react-solas-ors3';

export const KuwaitWarningMsg = () => (
  <Quote intent="warning" title="">
    <p>
      Original Statement of Entry and Venue letter will be ready for collection from the British Council at least two
      weeks before the start of the exams. An email and SMS will be sent for collection of the same from our office.
    </p>
    <p>On your exam day:</p>
    <ol type="I">
      <li>
        Please ensure to bring your Statement of Entry along with the original identity document which you have
        submitted at the time of registration.
      </li>
      <li>
        No mobile phones or electronic gadgets will be allowed inside the examination hall. Mobile phones should be
        switched off and left in the belongings area outside the examination room. Calculators will be allowed in an
        exam if permitted by the board.
      </li>
      <li>
        Kindly do not bring any valuables to the venue as the British Council will not be responsible for loss or damage
        to the same.
      </li>
      <li>
        Kindly note that Parents/guardians will not be allowed entry into the examination venue. Please familiarise
        yourself with the venue location in advance and make prior arrangements to get dropped to and picked up from the
        examination venue.
      </li>
      <li>
        Only stationery required for the examination in a transparent pouch and your Identity document are allowed to be
        taken inside the exam hall.
      </li>
    </ol>
  </Quote>
);
